import {showError} from '@/app/js/error'
import Inputmask from 'inputmask'

export function initAllRanges() {
  Inputmask({
    mask: ' 999',
    repeat: '*',
    greedy: false,
    numericInput: true,
    placeholder: '',
  }).mask(document.querySelectorAll('.js-mask-bigint'))

  document.querySelectorAll('.js-range').forEach(rangeEl => {
    new Range(rangeEl)
  })
}

export class Range {
  constructor(rangeEl) {
    this.el = rangeEl
    this.minError = rangeEl.dataset.minError
    this.maxError = rangeEl.dataset.maxError

    this.input = rangeEl.querySelector('.js-range-input')
    this.line = rangeEl.querySelector('.js-range-line')
    this.lever = rangeEl.querySelector('.js-range-lever')
    this.hidden = rangeEl.querySelector('.js-range-hidden')

    this.min = parseInt(this.input.min)
    this.max = parseInt(this.input.max)
    this.step = parseInt(this.input.step)
    this.stepsNum = (this.max - this.min) / this.step

    this.width = parseInt(this.line.offsetWidth)
    this.widthStep = Math.ceil(this.width / this.stepsNum)

    this.handleInput()
    this.handleDrag()
    this.setFillColor()
  }

  handleInput() {
    // this.input.addEventListener('input', () => {
    //   this.setValues(this.getValue())
    // })

    this.input.addEventListener('change', () => {
      const value = this.getValue()

      if (value > this.max) {
        showError(this.maxError)
        return this.setValues(this.max)
      }

      if (value < this.min) {
        showError(this.minError)
        return this.setValues(this.min)
      }

      if (value % this.step !== 0) {
        const roundedValue = this.step * Math.ceil(value / this.step)
        return this.setValues(roundedValue)
      }

      return this.setValues(value)
    })
  }

  handleDrag() {
    this.lever.addEventListener('input', () => {
      this.setValues(this.lever.value)
    })
  }

  setValues(value) {
    this.lever.value = value
    this.input.value = value
    this.hidden.value = value

    this.setFillColor()

    document.dispatchEvent(new Event('calc'))
  }

  setFillColor() {
    const valuePercent = (this.lever.value - this.lever.min) / (this.lever.max - this.lever.min) * 100
    this.lever.style.background = 'linear-gradient(to right, #f00 0%, #f00 ' + valuePercent + '%, #c1c1c1 ' + valuePercent + '%, #c1c1c1 100%)'
  }

  getValue() {
    if (this.input.inputmask) {
      return parseInt(this.input.inputmask.unmaskedvalue())
    }

    return parseInt(this.input.value)
  }
}